import React, { useEffect, useState, useRef } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import device from "current-device";

export function DeviceQueries() {
    
  /* MOB - Nav responsiveness - Wrapped up recently, if it causes any issues, go back to pasting this in each part where "queryMatches" is used*/
  const queryChecks = {
    inDesktopWidth: useMediaQuery("(min-width:768px)"),
    inMobileLandscapeHeight: useMediaQuery("(max-height:767.95px)"),
  };
  const sizeRef = useRef();
  sizeRef.current = queryChecks;
  const [viewOrientation, setViewOrientation] = useState(device.orientation);
  const orientationRef = useRef();
  orientationRef.current = viewOrientation;
  const [queryMatches, setQueryMatches] = useState(getQueryMatches());
  const matchesRef = useRef();
  matchesRef.current = queryMatches;

  let portraitCheck = window.matchMedia("(orientation: portrait)");

  useEffect(() => {
    // console.log(navigator.mediaDevices.getSupportedConstraints());
    handleViewOrientationChange();
    // console.log(queryChecks.inDesktopWidth);
    window.addEventListener("resize", handleViewOrientationChange);
    window.addEventListener("change", handleViewOrientationChange);
    portraitCheck.addEventListener("change", handleViewOrientationChange);
    return () => {
      window.removeEventListener("resize", handleViewOrientationChange);
      window.removeEventListener("change", handleViewOrientationChange);
      portraitCheck.removeEventListener("change", handleViewOrientationChange);
    };
  }, []);

  /* MOB - Get rid of debug properties*/
  function getQueryMatches() {
    let newMatches = {
      desktop: sizeRef.current.inDesktopWidth && !sizeRef.current.inMobileLandscapeHeight && device.type === "desktop",
      deviceLandscape: orientationRef.current === "landscape" && (sizeRef.current.inMobileLandscapeHeight || device.type !== "desktop"),
      devicePortrait: orientationRef.current === "portrait" && (!sizeRef.current.inDesktopWidth || device.type !== "desktop"),
      deviceLarge: sizeRef.current.inDesktopWidth && !device.type === "desktop",
      inDesktopWidth: queryChecks.inDesktopWidth,
      inLandscapeHeight: queryChecks.inMobileLandscapeHeight,
      debugViewOrientation: viewOrientation,
      debugOrientation: device.orientation,
      debugOrientationRef: orientationRef.current,
      debugDeviceType: device.type,
      debugSizeRef: sizeRef.current,
    };
    return newMatches;
  }

  function handleViewOrientationChange() {
    setTimeout(() => {
        setViewOrientation(device.orientation);
        setQueryMatches(getQueryMatches());
        //console.log(matchesRef.current);
    }, 150); // Dirty patch, seems safe with 200ms, but shouldn't be needed if it'd just took the correct values on load...
  }  
  /* End of "Wrappable section"*/

  return queryMatches;

}